import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Send, Mail, ShoppingBag, Sparkles, ShieldCheck } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

export default function ChiSiamo() {
  return (
    <div className="min-h-screen" data-testid="page-chi-siamo">
      <Seo
        title="Chi siamo"
        description="BrickDailyDeals è il punto di riferimento italiano per gli appassionati di set di costruzioni in cerca delle migliori offerte. Selezione manuale e automatica da Amazon, eBay, AliExpress."
        path="/chi-siamo"
      />
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          data-testid="chi-siamo-back"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-8"
        >
          <ArrowLeft size={14} /> Home
        </Link>

        <div className="font-mono-bdd text-xs uppercase tracking-[0.3em] text-[#FBD51C] mb-3">
          Il progetto
        </div>
        <h1 className="font-display font-black text-4xl text-white mb-3 tracking-tight">
          Chi siamo
        </h1>
        <p className="text-zinc-400 text-lg mb-10">
          BrickDailyDeals è il punto di riferimento italiano per gli appassionati
          di set di costruzioni alla ricerca delle migliori offerte online.
        </p>

        <div className="prose prose-invert max-w-none space-y-6 text-zinc-300 text-sm leading-relaxed">
          <section>
            <h2 className="font-display text-2xl text-white">La nostra missione</h2>
            <p>
              Ogni giorno passiamo in rassegna i principali store online — Amazon,
              eBay, AliExpress e altri — per scovare gli sconti più interessanti
              su set di costruzioni di tutte le linee. L&apos;obiettivo è semplice:
              farti risparmiare tempo e denaro, segnalandoti solo le offerte che
              valgono davvero la pena.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-white">Come funziona</h2>
            <ul className="space-y-3 list-none pl-0 mt-3">
              <li className="flex gap-3 items-start">
                <Sparkles size={18} className="text-[#FBD51C] mt-0.5 shrink-0" />
                <span>
                  <strong className="text-white">Selezione manuale e automatica</strong> — Un mix di curatela
                  umana e monitoraggio automatico dei prezzi sui principali store ci permette
                  di pubblicare decine di offerte al giorno.
                </span>
              </li>
              <li className="flex gap-3 items-start">
                <ShoppingBag size={18} className="text-[#FBD51C] mt-0.5 shrink-0" />
                <span>
                  <strong className="text-white">Tutti gli store, una sola fonte</strong> — Niente più
                  controlli infiniti su 5 siti diversi: qui trovi tutto raggruppato per categoria,
                  prezzo e percentuale di sconto.
                </span>
              </li>
              <li className="flex gap-3 items-start">
                <Send size={18} className="text-[#229ED9] mt-0.5 shrink-0" />
                <span>
                  <strong className="text-white">Canale Telegram in tempo reale</strong> —
                  Iscrivendoti al canale ricevi notifiche istantanee su ogni nuova offerta lampo.
                </span>
              </li>
              <li className="flex gap-3 items-start">
                <ShieldCheck size={18} className="text-emerald-400 mt-0.5 shrink-0" />
                <span>
                  <strong className="text-white">Trasparenza totale</strong> — Tutti i link sono
                  marcati come affiliati: se acquisti tramite essi guadagniamo una piccola
                  commissione (senza costi aggiuntivi per te) che ci permette di mantenere
                  il sito gratuito.
                </span>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl text-white">Per chi è</h2>
            <p>
              Per chi colleziona, per chi regala, per chi costruisce per hobby o
              per chi fa investimenti su set in pensione. Se cerchi un set
              specifico e vuoi pagarlo il giusto — o meno — sei nel posto giusto.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-white">Indipendenza editoriale</h2>
            <p>
              BrickDailyDeals è un progetto <strong>indipendente</strong>,
              non affiliato né sponsorizzato da The LEGO Group o da nessuno
              dei marchi citati. Tutti i marchi commerciali appartengono ai
              rispettivi proprietari. Le offerte segnalate sono frutto della
              nostra ricerca e selezione autonoma.
            </p>
          </section>

          <section className="border border-zinc-800 bg-zinc-900/60 rounded-2xl p-6 mt-10">
            <div className="flex items-start gap-4">
              <Mail size={22} className="text-[#FBD51C] mt-1" />
              <div>
                <h3 className="font-display text-xl text-white mb-2">Mettiamoci in contatto</h3>
                <p className="text-zinc-400 mb-4">
                  Hai un&apos;offerta da segnalare? Vuoi proporci una collaborazione?
                  Hai trovato un errore?
                </p>
                <Link
                  to="/contatti"
                  data-testid="chi-siamo-contatti-cta"
                  className="inline-flex items-center gap-2 bg-[#FBD51C] hover:bg-[#FFE552] text-black font-bold text-sm px-5 py-2.5 rounded-full transition-colors"
                >
                  Vai ai contatti
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
